module.exports = __webpack_public_path__ + "383f7a51f47ce8f83c3b1ce6202989c1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-15.png
// module id = 2245
// module chunks = 0